import { Image_DEPRECATED } from '@vcc-package/media/DEPRECATED';
import { ExtendCSS } from 'vcc-ui';

import {
  AspectRatio,
  ResponsiveAspectRatio,
  Sources,
} from '@collab/types/types';
import getAspectRatio from '@collab/utils/getAspectRatio';

import { imageWrapperStyle } from './Image.styles';

export type ImageProps = {
  src: string | Sources;
  alt: string;
  title?: string;
  aspectRatio?: AspectRatio | ResponsiveAspectRatio;
  extend?: ExtendCSS;
  className?: string;
};

const Image: React.FC<ImageProps> = ({
  alt,
  src,
  title,
  aspectRatio = [21, 9],
  extend,
  className,
}) => {
  return (
    <Image_DEPRECATED
      {...getImageSource(src)}
      alt={alt}
      title={title}
      className={className}
      aspectRatio={getAspectRatio(aspectRatio)}
      objectFit="cover"
      extend={[imageWrapperStyle, extend]}
      loading={
        !Array.isArray(aspectRatio) || !Array.isArray(src)
          ? 'native-lazy'
          : 'lazy'
      }
    />
  );
};

export const getImageSource = (src: string | Sources) => {
  if (typeof src === 'string') return { src };

  return {
    sources: {
      default: src.default,
      untilM: src.mobile,
    },
  };
};

export default Image;
